export type ThemeVariantId = "main" | "sepia" | "night";

export const getThemeVariantId = (variantName?: string): ThemeVariantId => {
  switch (variantName) {
    case "Sepia":
      return "sepia";
    case "Night":
      return "night";
    default:
      return "main";
  }
};
